import React from 'react';
import './Home.css';
import AnimatedSection from './components/AnimatedSection';
import { FaLinkedin, FaGithub } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { projects } from './data/projects';

function Home() {
  return (
    <main>
      {/* Hero Section */}
      <AnimatedSection>
        <section id="hero" className="hero">
          <div className="container">
            <div className="hero-content">
              <div className="hero-text">
                <h1>Hi, I'm Atabek Selman</h1>
                <p>Full Stack Developer</p>
                <div className="hero-buttons">
                  <a href="#projects" className="btn">My Projects</a>
                  <a href="#contact" className="btn btn-outline">Contact Me</a>
                </div>
              </div>
              <div className="hero-image">
                <img src="./profile.jpg" alt="Atabek Selman" />
                <div className="social-buttons">
                  <a href="https://linkedin.com/in/atabekhsa" className="social-button linkedin" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin size={28} />
                  </a>
                  <a href="https://github.com/atabek54" className="social-button github" target="_blank" rel="noopener noreferrer">
                    <FaGithub size={28} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </AnimatedSection>

      {/* About Section */}
      <AnimatedSection>
        <section id="about" className="section about">
          <div className="container">
            <h2>About Me</h2>
            <div className="about-content">
              <div className="about-text">
                <p>Hello, I'm Hiseyin Selman Atabek.</p>
                <p>Combining my Industrial Engineering background with software development, I create user-friendly, effective, and functional applications. Since 2023, I've been developing freelance mobile and web applications while also working as a Full Stack Developer at various startups.</p>
                <p>My expertise includes Flutter, React, React Native, Node.js, PHP, and MySQL. I prioritize clean code, performance, and user experience in all my applications.</p>
                <p>I enjoy working on projects that gamify real-life scenarios, building backend architectures, and creating systems that users want to use repeatedly.</p>
                <p>Currently, I continue to produce both individual and team-based projects while constantly improving my skills.</p>
              </div>
              <div className="skills">
                <h3>Skills</h3>
                <div className="skills-grid">
                  <div className="skill">React</div>
                  <div className="skill">Node.js</div>
                  <div className="skill">Python</div>
                  <div className="skill">JavaScript</div>
                  <div className="skill">HTML/CSS</div>
                  <div className="skill">MongoDB</div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </AnimatedSection>

      {/* Projects Section */}
      <AnimatedSection>
        <section id="projects" className="section projects">
          <div className="container">
            <h2>My Projects</h2>
            <div className="projects-grid">
              {projects.map((project, index) => (
                <div key={index} className="project-card">
                  <Link to={`/projects/${project.id}`}>
                    {project.video ? (
                      <div className="video-thumbnail">
                        <video muted loop>
                          <source src={project.video} type="video/mp4" />
                        </video>
                        <div className="play-icon">▶</div>
                      </div>
                    ) : (
                      <div className="default-thumbnail">
                        {project.title.charAt(0)}
                      </div>
                    )}
                    <div className="project-card-content">
                      <h3>{project.title}</h3>
                      <p>{project.description}</p>
                      <div className="tech-tag">
                        {project.technologies[0]}
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>
      </AnimatedSection>

      {/* Contact Section */}
      <AnimatedSection>
        <section id="contact" className="section contact">
          <div className="container">
            <h2>Contact</h2>
            <div className="contact-content">
              <div className="contact-info">
                <h3>Get In Touch</h3>
                <p><strong>Email:</strong> <a href="mailto:selmanatabek@hotmail.com">selmanatabek@hotmail.com</a></p>
                <p><strong>Phone:</strong> <a href="tel:+905344470058">+90 534 447 00 58</a></p>
              </div>
              <form className="contact-form">
                <input type="text" placeholder="Your Name" required />
                <input type="email" placeholder="Email" required />
                <textarea placeholder="Your Message" required></textarea>
                <button type="submit" className="btn">Send</button>
              </form>
            </div>
          </div>
        </section>
      </AnimatedSection>
    </main>
  );
}

export default Home;
